import { useOpenModal } from 'utils/modals';

import { OpenJobsModals } from './types';

export const useOpenReportPreparingModal = () =>
  useOpenModal<void>(OpenJobsModals.REPORT_PREPARING);
